import { useState } from 'react';
import { cn } from '@/utils/merge';

export const FloatingTextinput = ({
	value = '',
	onChange,
	label,
	type = 'text',
	// Which on-screen keyboard phones open, e.g. 'tel' for a phone keypad.
	inputMode,
	disabled,
	error,
	errorText,
	onBlur,
	onFocus,
	onKeyUp,
	styleContainer,
	white,
	labelBgColor,
	shouldLog,
	size,
	rightComponents,
	multiline = false,
	cnContainer = '',
	cnRightComponents = '',
	cnRightComponentLine = '',
}) => {
	const [focused, setFocused] = useState(false);
	// const [errorFlash, setErrorFlash] = useState(false);
	// const [successFlash, setSuccessFlash] = useState(false);
	const [validationResponse, setValidationResponse] = useState(null);

	// Not value?.length: numeric values (order fee / shopFee) have no .length, so
	// the label stayed unfloated and covered the value until the input was
	// focused. Compare the rendered text instead.
	const isFloating =
		focused || (value !== null && value !== undefined && `${value}`.length > 0);

	// const borderClass = disabled
	// 	? 'border-gray-200'
	// 	: error
	// 		? focused
	// 			? 'border-red-500'
	// 			: 'border-red-400'
	// 		: focused
	// 			? 'border-blue-500'
	// 			: 'border-gray-300';

	// const borderClass =
	// 	validationResponse === 0 ? 'border-green-500' : focused ? 'border-blue-500' : 'border-gray-300';

	const borderClass = disabled
		? 'border-slate-200'
		: error
			? 'border-red-500'
			: validationResponse === 0
				? 'border-green-500'
				: focused
					? 'border-blue-500'
					: 'border-slate-300';
	// 'border-slate-400'

	const labelColorClass = disabled
		? '!text-slate-500'
		: error
			? '!text-red-400'
			: // : validationResponse === 0
				// ? '!text-green-500'
				focused
				? '!text-indigo-600'
				: '!text-gray-600';
	// ? '!text-blue-500'
	// : '!text-gray-500';

	// const shadowClass = disabled
	// 	? ''
	// 	: error
	// 		? 'focus:shadow-[0_0_0_4px_rgba(239,68,68,0.5)]'
	// 		: 'focus:shadow-[0_0_0_4px_rgba(59,130,246,0.5)]';

	// const focusRing = !(focused && !error)
	// 	? ''
	// 	: validationResponse === 0
	// 		? 'ring-4 ring-green-500/5 border-green-500'
	// 		: 'ring-4 ring-blue-500/5 border-blue-500  ';

	// const focusRing =
	// 	validationResponse === 0
	// 		? 'ring-4 ring-green-500/10 border-green-500'
	// 		: validationResponse === 'exit'
	// 			? 'ring-4 ring-transparent border-gray-300 transition-all duration-100'
	// 			: focused
	// 				? 'ring-4 ring-blue-500/10 border-blue-500'
	// 				: '';

	const ringColor =
		validationResponse === 0
			? 'rgba(44,227,104,0.95)' // green
			: focused
				? 'rgba(59,130,246,0.25)' // blue
				: 'rgba(0,0,0,0.0)'; // neutral
	// : 'ring-transparent'; // neutral

	// const ringStyle = {
	// 	boxShadow: `0 0 0 2px ${ringColor}`,
	// 	transition: 'box-shadow 150ms ease, border-color 150ms ease',
	// };

	const flashFullClass =
		validationResponse === null
			? ''
			: validationResponse === 0
				? // ? 'animate-successBorder'
					''
				: validationResponse === 1
					? ''
					: validationResponse === 2
						? 'animate-errorRotate'
						: '';
	// const errorFullClass = errorFlash ? 'animate-errorBorder' : '';
	// const errorClass = errorFlash ? 'animate-errorBorder' : '';

	// const successFullClass = successFlash ? 'animate-successBorder' : '';
	// const successClass = successFlash ? 'animate-successBorder' : '';

	if (shouldLog) {
		console.log('*****', error, errorText);
	}

	const InputComponent = multiline ? 'textarea' : 'input';

	return (
		<div
			className={cn('relative mt-2.5 mb-2.5 w-[166px]', cnContainer)}
			style={{
				...styleContainer,
				...(!size
					? {}
					: {
							width:
								size === 'sm'
									? 96
									: size === 'lg'
										? 252
										: size === 'xl'
											? 324
											: size === 'full'
												? '100%'
												: undefined,
						}),
			}}
		>
			{/* {validationResponse === 0 && (
				<div className='animate-successRing pointer-events-none absolute inset-0 rounded-md' />
			)} */}
			<InputComponent
				type={type}
				inputMode={inputMode}
				className={cn(
					multiline ? 'h-16' : 'h-11.5',
					'w-full pt-1 pr-2 pb-1 pl-4',
					'rounded-md border-2 outline-none',
					'text-base',
					'transition-colors duration-150',
					borderClass,
					// errorFullClass, // 👈 here
					disabled ? 'cursor-not-allowed !text-slate-500' : '',
					// focused ? 'translate-y-[-0.5px]' : '',
					// focusRing,
					// successFullClass,
					flashFullClass,
					!white ? 'bg-[rgb(251,251,251)]' : 'bg-white',

					// shadowClass,
				)}
				style={rightComponents?.length > 0 ? { paddingRight: 52 } : undefined}
				value={value}
				onChange={e => {
					setValidationResponse(null);
					onChange(e.target.value);
				}}
				onBlur={() => {
					setFocused(false);

					const errorNumber = onBlur?.();
					// console.log('res onblur', errorNumber);
					// console.log('edoooooooooooooo', errorNumber);
					setValidationResponse(errorNumber);
					// setTimeout(() => {
					// 	setValidationResponse(null);
					// }, 700);

					setTimeout(() => {
						setValidationResponse('exit'); // intermediate state
					}, 100);

					setTimeout(() => {
						setValidationResponse(null);
					}, 300);

					// if (!errorNumber) {
					// 	setFlash(0)
					// }
					// console.log(isError);
					// if (isError) {
					// 	setErrorFlash(true);
					// 	setSuccessFlash(false);

					// 	setTimeout(() => {
					// 		setErrorFlash(false);
					// 	}, 700);
					// 	return;
					// }
					// setSuccessFlash(true);

					// setTimeout(() => {
					// 	setSuccessFlash(false);
					// }, 600);
					// setErrorFlash(false);
				}}
				onFocus={e => {
					setFocused(true);
					onFocus?.(e);
				}}
				onKeyUp={onKeyUp}
				disabled={disabled}
				placeholder=' '
				// style={styleContainer}

				// style={ringStyle}
			/>

			{rightComponents?.length > 0 && (
				<div
					className={cn(
						'absolute top-2.25 right-0 z-5 mx-0.5 flex flex-row items-center gap-x-0',
						cnRightComponents,
					)}
					style={{
						backgroundColor: white ? 'rgb(250,250,250)' : labelBgColor ? labelBgColor : undefined,
					}}
				>
					<div
						className={cn('mr-0.5 h-6.5 w-0.5 self-stretch bg-slate-300', cnRightComponentLine)}
					/>
					<div className='mr-0.75 flex flex-row items-center gap-x-0'>
						{rightComponents.map(rc => (
							<div
								key={rc.key}
								//  className='pt-4 ml-1.5 cursor-pointer'
								onClick={rc.onClick}
								className={cn('px-0.5 py-0.5', 'max-[800px]:px-0', rc.onClick && 'cursor-pointer')}
								// style=
							>
								{/* <MapPinPen size={22} /> */}
								{rc.component}
							</div>
						))}
					</div>
				</div>
			)}

			<label
				className={cn(
					// 'z-0',
					'absolute left-3 px-1.5',
					'pointer-events-none select-none',
					// 'bg-[rgb(242,242,242)]',
					'rounded-sm',
					!white ? 'bg-[rgb(247,247,247)]' : 'bg-white',
					// !white ? 'bg-transparent' : 'bg-white',

					'eas transition-all duration-[130ms] ease-in-out',
					isFloating
						? // ? focused
							// 	? 'top-0 translate-y-[calc(-50%-0.5px)] text-xs tracking-wide' :
							'top-0 -translate-y-1/2 text-[0.78rem] tracking-wide'
						: 'top-1/2 -translate-y-1/2 pl-1 text-[0.92rem] tracking-normal',
					labelColorClass,
					// errorClass,
					flashFullClass,
					// 'tracking-tight',
				)}
				style={
					white
						? { backgroundColor: 'rgb(250,250,250)' }
						: labelBgColor
							? { backgroundColor: labelBgColor }
							: undefined
				}
			>
				{error && errorText && value !== null && value !== undefined ? (
					<span className=''>
						{/* <span className='mx-1.5 opacity-60'>—</span> */}
						<span className='!text-red-500'>{errorText}</span>
					</span>
				) : (
					label
				)}
			</label>
		</div>
	);
};
